import { useState } from 'react';

import { BasicDialog, TextField, Typography } from '@opendoor/mosaic';

interface RejectDialogProps {
  onConfirm: (reason: string) => void;
  isOpen: boolean;
  onCancel: () => void;
}

const RejectDialog = (props: RejectDialogProps) => {
  const [reason, setReason] = useState<string>('');

  const handleConfirm = () => {
    props.onConfirm(reason);
  };

  return (
    <BasicDialog
      showCloseIcon={true}
      title="Rejection Reason"
      content={
        <>
          <Typography variant="body1" className="mb-2">
            Please share the reason for rejecting this work order.
          </Typography>
          <TextField
            type="text"
            label="Reason"
            className="w-100%"
            fullWidth
            placeholder="Reason for rejection"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
          />
        </>
      }
      open={props.isOpen}
      confirmDisabled={reason.trim() === ''}
      confirmLabel="Reject"
      onConfirm={handleConfirm}
      onCancel={props.onCancel}
      dialogProps={{
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      }}
    />
  );
};

export default RejectDialog;
